import Logo from '@/assets/ic_gdt-white.svg';
import { FullHeight } from '@/components';

const Splash = () => {
  return (
    <FullHeight
      className="bg-gdt-blue-dark flex items-center justify-center"
      tag="main"
    >
      <figure>
        <img alt="Splash Logo" className="w-28" src={Logo} />
      </figure>
    </FullHeight>
  );
};

export default Splash;
